import { BaseTable, Loading, TableHeader } from "components";
import { useListDataPost } from "../../utils";
import { BillType } from "pages/Card/Transaction/CreateNewVendor/types";
import moment from "moment";
import { APPROVAL, convertNumber } from "utils";

export function Bills(props: {
    dateFrom: string
    dateTo: string
    approval?: string
    vendorId: number,
    po?: string
    status?: string
}) {

    const { data, isLoading } = useListDataPost<BillType>("bill", {
        DateFrom: props.dateFrom,
        DateEnd: props.dateTo,
        Approval: props.approval,
        VendorID: props.vendorId,
        po: props.po,
        status: props.status
    })

    const totalBill = data.reduce((acc, item) => acc + item.total, 0)
    const totalPayment = data.reduce((acc, item) => acc + item.total_payment, 0)

    return (
        <div>
            <div className="overflow-x-auto mt-12 max-h-[700px]">
                <BaseTable className="border-collapse">
                    <TableHeader>
                        <tr>
                            <th>NO</th>
                            <th>BILL ID</th>
                            <th>PO ID</th>
                            <th>DATE</th>
                            <th>APPROVAL</th>
                            <th>QTY DELIVERED</th>
                            <th>LOCATION</th>
                            <th>TOTAL BILL</th>
                            <th>TOTAL PAYMENT</th>
                            <th>BALANCE OWING</th>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {isLoading || !data.length ? (
                            <tr>
                                <td colSpan={10}>
                                    <div className="w-full flex justify-center items-center">
                                        <Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} />
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index: number) => {
                                return (
                                    <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.trx_code_bill}</td>
                                    <td>{item.trx_code_po}</td>
                                    <td>{item.transaction_date ? moment(item.transaction_date).format("DD/MM/YYYY") : ""}</td>
                                    <td>{APPROVAL[item.approve_status]}</td>
                                    <td className="text-center">{item.qty_delivered ? convertNumber(item.qty_delivered).intoNormalAmount : "0"}</td>
                                    <td>{item.location_name}</td>
                                    <td className="text-right">{item.total ? convertNumber(item.total).intoCurrency : "0"}</td>
                                    <td className="text-right">{item.total_payment ? convertNumber(item.total_payment).intoCurrency : "0"}</td>
                                    <td className="text-right">{item.balance_owing ? convertNumber(item.balance_owing).intoCurrency : "0"}</td>
                                </tr>
                                )
                            }
                            )
                        )}
                    </tbody>
                </BaseTable>
            </div>
            <div className="mt-2 flex justify-end font-bold">
                <div className="flex flex-col gap-2">
                    <div className="flex">
                        <span className="mr-2 w-[150px]">Total Bill</span>
                        <span>:</span>
                        <span className="text-right ml-2">{ totalBill ? convertNumber(totalBill).intoCurrency : "0"}</span>
                    </div>
                    <div className="flex">
                        <span className="mr-2 w-[150px]">Total Payment</span>
                        <span>:</span>
                        <span className="text-right ml-2">{ totalPayment ? convertNumber(totalPayment).intoCurrency : "0"}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}